/**
 * Get a value from local storage by key.
 * @param {string} key - The name of the local storage item.
 * @returns {string | null} The stored value, or null if not found.
 */
export const getLocal = (key) => {
  return localStorage.getItem(key);
};

/**
 * Set a value in local storage with a given key.
 * @param {string} key - The name of the local storage item.
 * @param {string} value - The value to store.
 */
export const setLocal = (key, value) => {
  localStorage.setItem(key, value);
};

/**
 * Remove a value from local storage by key.
 * @param {string} key - The name of the local storage item to remove.
 */
export const removeLocal = (key) => {
  localStorage.removeItem(key);
};

/**
 * Clear all items in local storage.
 */
export const clearLocal = () => {
  localStorage.clear();
};
